"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sha256 = exports.hashPassword = exports.sha256base64url = exports.sha256hex = void 0;
const sha256_1 = __importDefault(require("./sha256"));
exports.Sha256 = sha256_1.default;
/**
 * @param {string} data
 * @return {string}
 */
function sha256hex(data) {
    const hashedData = new sha256_1.default().update(data).digest('hex');
    return /** @type {string} */ (hashedData);
}
exports.sha256hex = sha256hex;
/**
 * @param {string} data
 * @return {string}
 */
function sha256base64url(data) {
    const hashedData = new sha256_1.default().update(data).digest('base64url');
    return /** @type {string} */ (hashedData);
}
exports.sha256base64url = sha256base64url;
/**
 * @param {string} password
 * @return {{ digest: string, algorithm: string }}}
 */
function hashPassword(password) {
    const hashedPassword = {
        digest: sha256hex(password),
        algorithm: 'sha-256',
    };
    return hashedPassword;
}
exports.hashPassword = hashPassword;
//# sourceMappingURL=index.js.map